import * as actionTypes from "./types/configurationActionTypes";

export function toggleConfigurationMode() {
  return {
    type: actionTypes.TOGGLE_CONFIGURATION_MODE
  };
}

export function setKitchenConnectionState(kitchenConnectionUp) {
  return {
    type: actionTypes.SET_KITCHEN_CONNECTION_STATE,
    kitchenConnectionUp
  };
}

export function saveConfiguration(configuration) {
  return {
    type: actionTypes.SAVE_CONFIGURATION,
    configuration
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/configurationActions.js